import React, {FunctionComponent} from 'react';
import 'antd/dist/antd.css';
import {Button} from 'primereact/button';
import {Link, useNavigate} from 'react-router-dom';
import {Content, Parallax} from "../../App";
import Footer from "../../components/Footer";
import styled from "styled-components";

export const Grid = styled.div<{ columns: string, width?: number }>`
  display: grid;
  grid-gap: 3vh 2vw;
  align-items: start;

  @media only screen and (min-width: ${props => `${props.columns.split(' ').length * (props.width || 300)}px`}) {
    grid-template-columns: ${props => props.columns};
  }

  > div {
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
`;

const LogoImage = styled.img`
  max-width: 90vw;
  max-height: 30vh;

  //@media only screen and (min-width: 992px) {
  //  max-height: 20vh;
  //}
`;

const featureCardClassName = [
  'surface-card',
  'border-1',
  'border-200',
  'border-round-2xl',
  'shadow-2',
  'overflow-hidden',
].join(' ');

const sectionCardClassName = [
  'surface-card',
  'border-1',
  'border-200',
  'border-round-2xl',
  'shadow-1',
  'p-3',
  'md:p-5',
].join(' ');

const Home: FunctionComponent = () => {
  const navigate = useNavigate();

  return (
    <div className="home-page">
      <section className="relative overflow-hidden">
        <Parallax img={'IMG_1658-landscape.jpeg'} height={'82vh'}/>
        <div style={{top: '10vh'}} className="absolute left-0 right-0 bottom-0 flex lg:align-items-center overflow-scroll">
          <div className="w-full"
               style={{background: 'linear-gradient(90deg, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.48) 58%, rgba(0,0,0,0.18) 100%)'}}>
            <Content>
              <div className="grid align-items-center py-4 md:py-6 lg:py-7 text-white">
                <div className="col-12 lg:col-7">
                  <div
                    className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
                    style={{background: 'rgba(255,255,255,0.20)', backdropFilter: 'blur(8px)'}}
                  >
                    <i className="pi pi-calendar"/>
                    <span className="font-medium">Zaterdag 5 september • feest op het veld</span>
                  </div>

                  <h1 className="m-0 mb-3 text-4xl md:text-6xl line-height-1 font-bold color-orange">
                    10 jaar Groentegeweld
                  </h1>

                  <p className="text-lg md:text-2xl line-height-3 mb-4" style={{maxWidth: '720px'}}>
                    Het is zover: Groentegeweld bestaat 10 jaar! Dat vieren we op zaterdag 5 september met een feestelijke
                    dag op het veld met een groentebingo, veld-BBQ, een gezellig veldterras en livemuziek.
                  </p>

                  <div className="flex flex-wrap gap-3">
                    <Button
                      label={'Meer info over het feest'}
                      icon={'pi pi-arrow-right'}
                      iconPos={'right'}
                      className={'color-white bg-orange p-button-lg'}
                      onClick={() => navigate('/activiteiten#10-jaar-groentegeweld-feest')}
                    />
                    {/*<Button*/}
                    {/*  label={'Bekijk alle activiteiten'}*/}
                    {/*  icon={'pi pi-calendar'}*/}
                    {/*  iconPos={'right'}*/}
                    {/*  className={'p-button-lg p-button-outlined color-white text-sm'}*/}
                    {/*  onClick={() => navigate('/activiteiten')}*/}
                    {/*/>*/}
                  </div>
                </div>

                <div className="col-12 lg:col-5 flex justify-content-center lg:justify-content-end mt-4 lg:mt-0">
                  <img
                    src={'10-jaar-groentegeweld-flyer.jpg'}
                    alt={'Affiche 10 jaar Groentegeweld'}
                    className="block w-full border-round-2xl shadow-2"
                    style={{
                      maxWidth: '420px',
                      maxHeight: '66vh',
                      objectFit: 'contain',
                    }}
                  />
                </div>
              </div>
            </Content>
          </div>
        </div>
      </section>


      <Content>
        <div className="py-4 md:py-5">
          <div
            className="surface-card border-1 border-200 border-round-2xl shadow-2 p-4 md:p-5"
            style={{
              background: 'linear-gradient(135deg, rgba(116, 143, 86, 0.10) 0%, rgba(238, 122, 49, 0.08) 100%)',
            }}
          >
            <div className="grid align-items-center">
              <div className="col-12 md:col-8">
                <div className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
                     style={{background: 'var(--green-20)'}}>
                  <i className="pi pi-map-marker"/>
                  <span className="font-medium">Nieuwe afhaalpunten</span>
                </div>

                <h2 className="mt-0 mb-3 text-3xl md:text-4xl">
                  Vanaf nu ook afhalen in Riel en Alphen
                </h2>

                <p className="text-lg line-height-3 mb-4" style={{maxWidth: '760px'}}>
                  Goed nieuws: je kan je groentepakket nu ook ophalen op twee extra locaties.
                  Zo wordt deelnemen nog makkelijker, met een afhaalpunt dichter bij huis.
                </p>

                <div className="grid">
                  <div className="col-12 md:col-6">
                    <div
                      className="surface-card border-1 border-200 border-round-2xl p-3 h-full flex align-items-center gap-3 mb-3">
                      <div className="">
                        <img
                          src={'deliveryLocations/vantzandeind.png'}
                          alt={'Logo Alphen 2'}
                          style={{maxWidth: '140px', maxHeight: '70px', objectFit: 'contain'}}
                        />
                      </div>
                      <div>
                        <div className="flex align-items-center gap-2 mb-2 text-lg">
                          <i className="pi pi-map-marker color-orange"/>
                          <strong>Riel</strong>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 md:col-6">
                    <div
                      className="surface-card border-1 border-200 border-round-2xl p-3 h-full flex align-items-center gap-3 mb-3">
                      <div className="">
                        <img
                          src={'deliveryLocations/oard.png'}
                          alt={'Logo Alphen 1'}
                          style={{maxWidth: '140px', maxHeight: '70px', objectFit: 'contain'}}
                        />
                      </div>

                      <div>

                        <div className="flex align-items-center gap-2 mb-2 text-lg">
                          <i className="pi pi-map-marker color-orange"/>
                          <strong>Alphen</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 md:col-4">
                <div className="flex flex-column gap-3 md:align-items-end">
                  <Button
                    label={'Meer info over pakketten'}
                    icon={'pi pi-arrow-right'}
                    iconPos={'right'}
                    className={'p-button-lg p-button-outlined p-button-green'}
                    onClick={() => navigate('/pakketten')}
                  />
                  <Button
                    label={'Direct inschrijven'}
                    icon={'pi pi-external-link'}
                    iconPos={'right'}
                    className={'p-button-lg bg-orange color-white'}
                    onClick={() => window.open('https://www.mijnboer.be/groentegeweld/inschrijven/pakketten', '_blank')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>

      <Content>
        <div className="py-4 md:py-6">
          <div className="mb-4 flex flex-column align-items-center text-center">
            <div className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
                 style={{background: 'var(--green-20)'}}>
              <i className="pi pi-home"/>
              <span className="font-medium">Onze formules</span>
            </div>
            <h2 className="mt-0 mb-2 text-3xl md:text-4xl">Kies wat bij jou past</h2>
            <p className="m-0 text-lg line-height-3" style={{maxWidth: '760px'}}>
              Twee manieren om mee te doen: zelf oogsten op het veld, of werken met een groentepakket.
            </p>
          </div>

          <div className="grid">
            <div className="col-12 lg:col-6 md:col-6 lg:col-3">
              <div className={featureCardClassName + ' h-full'}>
                <img src={'IMG_7041.jpg'} alt={'Zelfoogst'} className="block w-full"
                     style={{height: '240px', objectFit: 'cover'}}/>
                <div className="p-4">
                  <h3 className="mt-0 mb-2 text-2xl">Zelfoogst</h3>
                  <p className="line-height-3 mb-4">
                    Hou je van rust, frisse lucht en ontdekken wat er op het veld te vinden valt? Dan ben je een geboren
                    zelfoogster.
                  </p>
                  <div className="flex justify-content-end">
                    <Button
                      label={'Ontdek onze zelfoogst'}
                      icon={'pi pi-arrow-right'}
                      iconPos={'right'}
                      className={'p-button-outlined p-button-orange'}
                      onClick={() => navigate('/zelfoogst')}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 lg:col-6 md:col-6 lg:col-3">
              <div className={featureCardClassName + ' h-full'}>
                <img src={'IMG_7906.jpg'} alt={'Pakketten'} className="block w-full"
                     style={{height: '240px', objectFit: 'cover'}}/>
                <div className="p-4">
                  <h3 className="mt-0 mb-2 text-2xl">Pakketten</h3>
                  <p className="line-height-3 mb-4">
                    Wekelijks verse groenten met keuzevrijheid. Pas aan, wissel of sla een week over.
                  </p>
                  <div className="flex justify-content-end">
                    <Button
                      label={'Ontdek onze flexibele pakketten'}
                      icon={'pi pi-arrow-right'}
                      iconPos={'right'}
                      className={'p-button-outlined p-button-green'}
                      onClick={() => navigate('/pakketten')}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 lg:col-6 md:col-6 lg:col-3">
              <div className={featureCardClassName + ' h-full'}>
                <img src={'139 groentegeweld.jpg'} alt={'Veldwinkel'} className="block w-full"
                     style={{height: '240px', objectFit: 'cover'}}/>
                <div className="p-4">
                  <h3 className="mt-0 mb-2 text-2xl">Veldwinkel</h3>
                  <p className="line-height-3 mb-4">
                    Wil je de vrijheid om te bestellen wanneer het jou uitkomt? Maak kennis met onze smaken en proef ons
                    aanbod al eens een keertje.
                    In onze online veldwinkel vind je ons seizoensgebonden aanbod met de beste smaken.
                  </p>
                  <div className="flex justify-content-end">
                    <Button
                      label={'Bezoek de veldwinkel'}
                      icon={'pi pi-arrow-right'}
                      iconPos={'right'}
                      className={'p-button-outlined p-button-orange'}
                      onClick={() => navigate('/veldwinkel')}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 lg:col-6 md:col-6 lg:col-3">
              <div className={sectionCardClassName + ' h-full flex flex-column justify-content-between'}>
                <div>

                  <h3 className="mt-0 mb-3 text-2xl">Kort, lokaal en smaakvol</h3>
                  <ul className="m-0 pl-3 line-height-3">
                    <li>Biologisch en ecologisch</li>
                    <li>Meer dan 60 verschillende gewassen</li>
                    <li>Afgestemd op de seizoenen</li>
                    <li>Een directe band met de boer</li>
                  </ul>
                </div>

                <div className="mt-4 pt-3 border-top-1 border-200">
                  <div className="flex justify-content-between align-items-center mb-2">
                    <span className="font-medium">Biologisch</span>
                    <i className="pi pi-check-circle" style={{color: 'var(--green)'}}/>
                  </div>
                  <div className="flex justify-content-between align-items-center mb-2">
                    <span className="font-medium">Bodemzorg</span>
                    <i className="pi pi-check-circle" style={{color: 'var(--green)'}}/>
                  </div>
                  <div className="flex justify-content-between align-items-center">
                    <span className="font-medium">Seizoensgebonden</span>
                    <i className="pi pi-check-circle" style={{color: 'var(--green)'}}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>


      <section className="my-4 md:my-6">
        <Parallax img={'zonnebloem.jpg'} height={'220px'}/>
      </section>

      <Content>
        <div className="py-4 md:py-5">
          <div
            className="surface-card border-1 border-200 border-round-2xl shadow-2 p-4 md:p-5"
            style={{
              background: 'linear-gradient(135deg, rgba(116, 143, 86, 0.10) 0%, rgba(238, 122, 49, 0.08) 100%)',
            }}
          >
            <div className="grid align-items-center">
              <div className="col-12 md:col-8">
                <div className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
                     style={{background: 'var(--green-20)'}}>
                  <i className="pi pi-leaf"/>
                  <span className="font-medium">Biologisch • ecologisch • lokaal</span>
                </div>

                <h2 className="mt-0 mb-3 text-3xl md:text-4xl">
                  Ons verhaal
                </h2>

                <p className="text-lg line-height-3 mb-0" style={{maxWidth: '760px'}}>
                  Groentegeweld is een biologisch tuinbouwbedrijf waar persoonlijk contact, bodemkwaliteit en pure
                  smaak voorop staan. Kleinschalig en met zorg voor bodem en mens.
                </p>
              </div>

              <div className="col-12 md:col-4">
                <div className="flex flex-column gap-3 md:align-items-end">
                  <Button
                    label={'Verken flexibele pakketten'}
                    icon={'pi pi-arrow-right'}
                    iconPos={'right'}
                    className={'p-button-lg p-button-outlined p-button-green text-sm md:text-base'}
                    onClick={() => navigate('/pakketten')}
                  />
                  <Button
                    label={'Ontdek zelfoogst'}
                    icon={'pi pi-arrow-right'}
                    iconPos={'right'}
                    className={'p-button-lg bg-orange color-white text-sm md:text-base'}
                    onClick={() => navigate('/zelfoogst')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>
      <Content>
        <div className="py-5 md:py-6">
          <div className="grid">
            <div className="col-12 lg:col-7">
              <div className={sectionCardClassName}>
                <div className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
                     style={{background: 'var(--green-20)'}}>
                  <i className="pi pi-book"/>
                  <span className="font-medium">Ons verhaal</span>
                </div>

                <h2 className="mt-0 mb-3 text-3xl md:text-4xl">
                  Recht van het veld, met respect voor bodem en smaak
                </h2>

                <p className="text-lg line-height-3 mb-3">
                  Groentegeweld is een <strong>bio-ecologisch</strong> tuinbouwbedrijf met een bewuste focus op
                  kwaliteit. We telen groenten en sinds kort ook (klein-)fruit.
                  Is echt ecologische landbouw op mensenmaat mogelijk? Dat is de uitdaging die Willem en Dirk aangaan
                  met persoonlijke aandacht voor elke plant en directe verbinding met wie ervan geniet.
                </p>

                <h3 className="mt-4 mb-2 text-2xl">Hoe geniet jij mee?</h3>

                <p className="text-lg line-height-3 mb-0">
                  Je kan bij ons <Link to={'/zelfoogst'}>zelfoogster</Link> worden of een <Link
                  to={'/pakketten'}>groentepakket</Link> afnemen.
                  Je bent bij ons niet zomaar een klant, maar een <Link to={'/csa'}>(oogst)aandeelhouder</Link>.
                  Met dat aandeel zorg je voor heerlijke, seizoensgebonden groenten op je bord.
                </p>
              </div>
            </div>

            <div className="col-12 lg:col-5">
              <div className={featureCardClassName}>
                <img
                  src={'125 groentegeweld.jpg'}
                  alt={'Groentegeweld op het veld'}
                  className="block w-full"
                  style={{height: '100%', minHeight: '320px', objectFit: 'cover'}}
                />
              </div>
            </div>
          </div>

          <div className="grid mt-4 md:mt-5">
            <div className="col-12 lg:col-5 lg:order-2">
              <div className={featureCardClassName}>
                <img
                  src={'139 groentegeweld.jpg'}
                  alt={'Bodem en veld'}
                  className="block w-full"
                  style={{height: '100%', minHeight: '320px', objectFit: 'cover'}}
                />
              </div>
            </div>

            <div className="col-12 lg:col-7 lg:order-1">
              <div className={sectionCardClassName}>
                <div className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
                     style={{background: 'var(--orange-20)'}}>
                  <i className="pi pi-sun"/>
                  <span className="font-medium">Hoe doen we dat op het veld?</span>
                </div>

                <h2 className="mt-0 mb-3 text-3xl md:text-4xl">
                  De bodem is de grond van de zaak
                </h2>

                <p className="text-lg line-height-3 mb-3">
                  We ploegen of frezen niet, maar laten de natuur zijn werk doen. Lang leve de regenwormen.
                  We zoeken steeds een ecologisch evenwicht: nestkastjes, biodiversiteit en slimme samenwerking met de
                  natuur.
                </p>

                <p className="text-lg line-height-3 mb-0">
                  Dit is niet de makkelijkste weg, maar wel onze visie op landbouw: economisch en ecologisch,
                  kleinschalig maar efficiënt, dicht bij de klant.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Content>


      <section className="my-4 md:my-6">
        <Parallax img={'zonnebloem.jpg'} height={'180px'}/>
      </section>

      <Content>
        <div className="py-4 md:py-6">
          <div className="grid align-items-center">
            <div className="col-12 md:col-4 text-center md:text-left">
              <img
                src={'IMG_5657.jpg'}
                alt={'Pakket en veld'}
                className="block w-full border-round-2xl shadow-2"
                style={{maxHeight: '320px', objectFit: 'cover'}}
              />
            </div>

            <div className="col-12 md:col-8">
              <div className={sectionCardClassName}>
                <div className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
                     style={{background: 'var(--orange-20)'}}>
                  <i className="pi pi-shopping-cart"/>
                  <span className="font-medium">Ook handig om te weten</span>
                </div>

                <h2 className="mt-0 mb-3 text-3xl md:text-4xl">Pakketten met ritme en ruimte</h2>

                <p className="text-lg line-height-3 mb-0">
                  Als pakketdeelnemer krijg je onze verse groenten aangeboden in een herbruikbare box.
                  We vullen jouw pakket tweewekelijks met een variatie van het veld, volledig mee met de seizoenen.
                  Je kiest zelf een periode die bij jouw gezin past.
                </p>

                <div className="mt-4 flex flex-wrap gap-3">
                  <Button
                    label={'Ontdek onze pakketten'}
                    icon={'pi pi-arrow-right'}
                    iconPos={'right'}
                    className={'p-button-outlined p-button-green'}
                    onClick={() => navigate('/pakketten')}
                  />
                  <Button
                    label={'Word deelnemer'}
                    icon={'pi pi-external-link'}
                    iconPos={'right'}
                    className={'p-button-warning'}
                    onClick={() => window.open('https://www.mijnboer.be/groentegeweld/inschrijven', '_blank')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>

      <Footer/>
    </div>
  );
};

export default Home;
